<span *ngFor="let data of filterArr;let i=index;" class="quick_range" >
    <button type="button" [disabled]="data.disableFlag"  [ngClass]="{'selected': !data.disableFlag && data.flag , 'deselected' : !data.disableFlag && data.flag == false}" class="cstm_btn_css" (click)="onfilterClick(data,filterArr)" >{{data.name}}</button>
        <!-- <p>{{ msgFromFilter }}</p> -->
</span>

